class OfficesBlock {
  /**
   * Add custom JavaScript to the block HTML.
   *
   * @param   Element  block       The block element
   * @param   object   attributes  The block attributes (only available when editing)
   * @return  void
   */
  constructor(block, attributes = null) {
    this.block = block;
    this.items = block.querySelectorAll('.offices__item');

    this.items.forEach((item) => {
      item.addEventListener('mouseenter', () => this.updatePopupPosition(item));
      item.addEventListener('click', () => this.updatePopupPosition(item));
    });
  }

  updatePopupPosition(item) {
    const offset = item.getBoundingClientRect();
    const popup = item.querySelector('.offices__popup');

    if (offset.width + offset.left + popup.offsetWidth < window.innerWidth + 32) {
      popup.classList.remove('offices__popup--left');
    } else {
      popup.classList.add('offices__popup--left');
    }
  }
}

// Initialize each block on page load (front end)
document.querySelectorAll('.offices').forEach((block) => {
  new OfficesBlock(block);
});

window.addEventListener('init', () => {
  document.querySelectorAll('.offices').forEach((block) => {
    new OfficesBlock(block);
  });
});

// Initialize the dynamic block preview (editor)
if (window.acf) {
  window.acf.addAction('render_block_preview/type=offices', ($block, attributes) => {
    new OfficesBlock($block.find('.offices').get(0), attributes);
  });
}